module.exports = "0.36.0";



//////////////////
// WEBPACK FOOTER
// ./node_modules/autocomplete.js/version.js
// module id = 18
// module chunks = 0